<template>
	<div class="tw-mt-6 tw-max-w-[750px] tw-text-xl tw-text-gray-950">
		<div class="tw-flex tw-gap-2">
			<span>1.</span>
			<p>
				{{ $t('integrations.visit-the-catalogs-page-on-your-meta-account') }}
				<a
					class="tw-text-blue-500 tw-underline hover:tw-underline"
					href="https://business.facebook.com/latest/whatsapp_manager/catalog/?nav_ref=whatsapp_manager&is_from_mbs=1&business_id=254843552892025&asset_id=357255454146186"
					target="_blank"
				>
					{{ $t('integrations.here') }}
				</a>
			</p>
		</div>

		<div class="tw-my-3 tw-h-[1px] tw-bg-gray-300" />
		<div>
			<div class="tw-mb-1 tw-flex tw-gap-2">
				<span>2.</span>
				<p>
					<span
						>{{
							$t(
								'integrations.after-logging-into-your-account-you-should-find-the-page-below-select-your',
							)
						}}
					</span>
					<span class="tw-mx-1 tw-text-brand-500"> {{ $t('integrations.add') }} </span>
					<span> {{ $t('integrations.and-select') }} </span>
					<span class="tw-mx-1 tw-text-brand-500">
						{{ $t('integrations.create-new-catalog') }}
					</span>
					<span> {{ $t('integrations.from-the-dropdown') }}</span>
				</p>
			</div>
			<img :src="`${imgUrl}/new-catalog.webp`" class="tw-rounded-sm" />
		</div>

		<div class="tw-my-3 tw-h-[1px] tw-bg-gray-300" />
		<div>
			<div class="tw-mb-1 tw-flex tw-gap-2">
				<span>3.</span>
				<p>
					<span>{{ $t('integrations.select') }} </span>
					<span class="tw-mx-1 tw-inline-block tw-text-brand-500">
						{{ $t('integrations.online-products-1') }}
					</span>
					<span
						>{{
							$t(
								'integrations.from-product-category-make-sure-the-business-you-want-to-use-the-selected-under-business-portfolio-2-and-set-the',
							)
						}}
					</span>
					<span class="tw-mx-1 tw-inline-block tw-text-brand-500">
						{{ $t('integrations.name-3') }}
					</span>
					<span> {{ $t('integrations.to-linker-catalog') }} </span>
				</p>
			</div>
			<img :src="`${imgUrl}/add-basic-info.png`" class="tw-rounded-sm" />
		</div>

		<div class="tw-my-3 tw-h-[1px] tw-bg-gray-300" />
		<div>
			<div class="tw-mb-1 tw-flex tw-gap-2">
				<span>4.</span>
				<p>
					<span>{{ $t('integrations.skip-the-connect-to-tracking-step-by-clicking') }} </span>
					<span class="tw-mx-1 tw-inline-block tw-text-brand-500">
						{{ $t('integrations.next') }}
					</span>
				</p>
			</div>
			<img :src="`${imgUrl}/connect-to-event-tracking.webp`" class="tw-rounded-sm" />
		</div>

		<div class="tw-my-3 tw-h-[1px] tw-bg-gray-300" />
		<div>
			<div class="tw-mb-1 tw-flex tw-gap-2">
				<span>5.</span>
				<p>
					<span>{{ $t('integrations.under-set-permissions-select') }} </span>
					<span class="tw-mx-1 tw-text-brand-500"> {{ $t('integrations.partners') }} </span>
					<span>{{ $t('integrations.1-and-then-click') }} </span>
					<span class="tw-mx-1 tw-inline-block tw-text-brand-500">
						{{ $t('integrations.assign-partner') }}
					</span>
					<span class="tw-inline-block">{{ $t('integrations.2-and-choose-by') }} </span>
					<span class="tw-mx-1 tw-text-brand-500"> {{ $t('integrations.business-ID') }} </span>
					<span> 3 </span>
				</p>
			</div>
			<img :src="`${imgUrl}/set-permissions.png`" class="tw-rounded-sm" />
		</div>

		<InviteAndAssignAccess :stepNumber="6" :imgUrl="imgUrl" />

		<div class="tw-my-3 tw-h-[1px] tw-bg-gray-300" />
		<div>
			<div class="tw-mb-1 tw-flex tw-gap-2">
				<span>7.</span>
				<p>
					<span
						>{{
							$t(
								'integrations.under-the-upload-products-select-step-as-we-be-adding-products-in-a-later-step',
							)
						}}
					</span>
				</p>
			</div>
			<img :src="`${imgUrl}/how-to-upload-products.png`" class="tw-rounded-sm" />
		</div>

		<div class="tw-my-3 tw-h-[1px] tw-bg-gray-300" />
		<div>
			<div class="tw-mb-1 tw-flex tw-gap-2">
				<span>8.</span>
				<p>
					<span
						>{{
							$t(
								'integrations.next-we-need-to-link-your-catalog-to-your-whatsapp-number-visit-your-whatsapp-manager',
							)
						}}
					</span>
					<a
						class="tw-mx-1 tw-inline-block tw-text-blue-500 tw-underline hover:tw-underline"
						href="https://business.facebook.com/latest/whatsapp_manager/catalog/?nav_ref=whatsapp_manager&is_from_mbs=1&business_id=254843552892025&asset_id=357255454146186"
						target="_blank"
					>
						{{ $t('integrations.here') }}
					</a>
					<span>.</span>
					<span>{{ $t('integrations.and-click-on') }} </span>
					<span class="tw-mx-1 tw-inline-block tw-text-brand-500">
						{{ $t('integrations.choose-a-catalog') }}
					</span>
					<span>.</span>
				</p>
			</div>
			<img :src="`${imgUrl}/choose-catalog.png`" class="tw-rounded-sm" />
		</div>

		<div class="tw-my-3 tw-h-[1px] tw-bg-gray-300" />
		<div>
			<div class="tw-mb-1 tw-flex tw-gap-2">
				<span>9.</span>
				<p>
					<span
						>{{
							$t('integrations.choose-the-catalog-we-created-1-and-click-create-catalog-2')
						}}
					</span>
				</p>
			</div>
			<img :src="`${imgUrl}/connect-a-catalog.png`" class="tw-rounded-sm" />
		</div>

		<div class="tw-my-3 tw-h-[1px] tw-bg-gray-300" />
		<div>
			<div class="tw-mb-1 tw-flex tw-gap-2">
				<span>10.</span>
				<p>
					<span>{{ $t('integrations.last-step-link-your') }} </span>
					<span class="tw-mx-1 tw-inline-block tw-text-brand-500">
						{{ $t('integrations.whatsapp-number') }}
					</span>
					<span>{{ $t('integrations.1-and-make-sure-to') }} </span>
					<span class="tw-mx-1 tw-inline-block tw-text-brand-500">
						{{ $t('integrations.turn-on-your-catalog-and-cart') }}
					</span>
					<span>(2) (3)</span>
				</p>
			</div>
			<img :src="`${imgUrl}/connect-a-catalog.png`" class="tw-rounded-sm" />
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import InviteAndAssignAccess from './components/invite-and-assign-access';

const imgUrl = 'assets/v2/image/whatsapp/catalog';
</script>

<style lang="scss" scoped></style>
